// Safely open an external URL in a new tab: validate the scheme (http/https
// only — blocks javascript:/data:) and set noopener,noreferrer (anti-tabnabbing).
// Shared by the Meeting Hub widget and the community-calendar popup so the guard
// lives in one place. (RES-638)
export function openExternalUrl(url: string | null | undefined): void {
  if (!url) {
    return;
  }
  try {
    const parsed = new URL(url);
    if (parsed.protocol === 'https:' || parsed.protocol === 'http:') {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  } catch {
    // Invalid URL — do nothing.
  }
}
